<div class="ManageLinkDialog">
    <sync-dialog [config]="{
        title: 'Share link',
        subTitle: fileName,
        isClosable: true,
        onCloseIcon: onBack,
        actionButton: isEnced && 'Save',
        cancelButton: isEnced ? 'Cancel' : 'Close',
        onActionClick: onSubmit,
        onCancelClick: closeManageLinkDialog,
        isButtonLoading: isButtonLoading,
        isActionButtonDisabled: isActionButtonDisabled,
    }" [open]="showManageLinkDialog" [isFullScreen]="false" [onClose]="closeManageLinkDialog">
        <app-error
            *ngIf="errcode"
            [errcode]="errcode"
        ></app-error>

        <div class="link-manage-container" *ngIf="linkForm" [formGroup]="linkForm">
            <div class="loading-state" *ngIf="!isEnced">
                <sync-spinner></sync-spinner>
                <p class="subtitle-1">{{modalText}}</p>
            </div>
            <div class="link-alert" *ngIf="link.is_expired">
                <sync-alert class="body-2" [type]="'warning'"
                [leadIcon]="'warning'"
                [showLeadIcon]="true"
                [description]="'This link has expired and is no longer viewable.'"
                [title]="''"
                [showActions]="false"
                [showCloseButton]="false"
                ></sync-alert>
            </div>
            <div class="link-alert" *ngIf="link.is_download_limit">
                <sync-alert class="body-2" [type]="'warning'"
                [leadIcon]="'warning'"
                [showLeadIcon]="true"
                [description]="!isPro 
                        ? 'This link has reached it’s download limit and is no longer viewable. Upgrade your plan to get unlimited downloads.'
                        : 'This link has reached it’s download limit and is no longer viewable.'"
                [title]="''"
                [showActions]="!isPro"
                [showPrimaryAction]="!isPro"
                [primaryButtonConfig]="{ label: 'Upgrade', onClick: onUpgradeClick }"
                [showCloseButton]="false"
                ></sync-alert>
            </div>

            <div class="share-link" *ngIf="isEnced">
                <sync-text-field class="link-url" id="link-url" [label]="'Link URL'" [inputType]="'text'" [leadAdornments]="false"
                    [trailAdornments]="true" trailAdornmentsType="icon" [trailIconAdornment]="'copy-file'" [value]="shareLinkUrl"
                    [placeholder]="'Input'" [readOnly]="true" (click)="handleCopy(shareLinkUrl)"></sync-text-field>
                <div class="link-buttons">
                    <a class="open-link" [href]="link.linkUrl" target="_blank" *ngIf="link.togglePassword">
                    <sync-button (click)="handleOpen()" [label]="'Open link'" [type]="'outlined'" [leadAdornment]="true"
                        [leadIconAdornment]="'open-in-new'">
                    </sync-button>
                    </a>
                    <sync-button [label]="'Copy link'" [type]="'outlined'" [leadAdornment]="true"
                        [leadIconAdornment]="'copy-file'" (click)="handleCopy(shareLinkUrl)" id="copy-link-btn"> </sync-button>
                    <sync-button *ngIf="link.compat && (isPro && !isOnTrial) && isEnced" [label]="'Share via email'" [type]="'outlined'" [leadAdornment]="true"
                        [leadIconAdornment]="'email'" [onClick]="onShareViaEmail.bind(this)"></sync-button>
                </div>
            </div>

            <sync-divider *ngIf="isEnced"></sync-divider>
            <sync-section-header *ngIf="isEnced" [header]="'Link settings'"  [level]="'h4'" [showActions]="true" [showButton]="true" 
                [buttonConfig]="isSmallScreen?{label: '', type: 'flat', color: 'default', size:'small', leadAdornment:true, leadIconAdornment:'settings', onClick: onAdvanceSettings.bind(this)}:{label: 'Advanced settings', type: 'flat', color: 'default', size:'small', leadAdornment:true, leadIconAdornment:'settings', onClick: onAdvanceSettings.bind(this)}">
            </sync-section-header>

            <app-permissions-link-form
                *ngIf="isEnced"
                formControlName="permissionsForm"
                [link]="link"
                [fileType]="fileType"
                [item]="item">
            </app-permissions-link-form>

        </div>
    </sync-dialog>
</div>